An array of field-level validation errors associated with the reason.

This will be null if there are no field-level details.
